import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    if (!/^[^@]+@[^@]+\.[^@]+$/.test(email)) { toast.error("Enter a valid email address"); return; }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/subscribe`, { email, source: "newsletter" });
      localStorage.setItem("mx_email", email);
      if (data.welcome_code) {
        localStorage.setItem("mx_promo", JSON.stringify({ code: data.welcome_code, percent: data.discount_percent }));
        toast.success(`You're on the list. Code ${data.welcome_code} = ${data.discount_percent}% off your first order.`, { duration: 9000 });
      } else {
        toast.success("You're on the list.");
      }
      setEmail("");
    } catch { toast.error("Something went wrong."); }
    finally { setLoading(false); }
  };
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32" data-testid="newsletter">
      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        className="border border-zinc-800 bg-[#0C0C0C] p-10 md:p-20 text-center">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-6">Stay Informed</p>
        <h2 className="font-serif text-4xl md:text-6xl font-light leading-tight mb-6 max-w-2xl mx-auto">New compounds. Private pricing. First access.</h2>
        <p className="text-[#A1A1AA] max-w-lg mx-auto mb-10">Join the mailing list for research drops and member-only promotions.</p>
        <div className="max-w-md mx-auto flex flex-col sm:flex-row gap-4">
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="your@email.com" data-testid="newsletter-input"
            className="flex-1 bg-transparent border-b border-zinc-600 focus:border-[#D4AF37] outline-none py-3 text-center sm:text-left font-serif text-lg placeholder:text-[#52525B] transition-colors" />
          <button onClick={submit} disabled={loading} data-testid="newsletter-submit"
            className="bg-[#D4AF37] text-black px-8 py-3 font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#C5A028] transition-colors disabled:opacity-50">
            {loading ? "…" : "Subscribe"}
          </button>
        </div>
      </motion.div>
    </section>
  );
}
